export class ParticipantDetailProperties {
  fullname: string
  initials: string
  participantId: number
  sid: string
  isMuted: boolean
  cameraShown: boolean// ne treba ama ostaj go 
}